@use '@ongov/ontario-design-system-global-styles/dist/styles/scss/1-variables/global.variables' as globalVariables;
@use '@ongov/ontario-design-system-global-styles/dist/styles/scss/1-variables/spacing.variables' as spacing;
@use '@ongov/ontario-design-system-global-styles/dist/styles/scss/1-variables/colours.variables' as colours;
@use '@ongov/ontario-design-system-global-styles/dist/styles/scss/1-variables/fonts.variables' as fonts;
@use '@ongov/ontario-design-system-global-styles/dist/styles/scss/2-tools/placeholder/focus.placeholders' as
	focusPlaceholders;
@use '@ongov/ontario-design-system-global-styles/dist/styles/scss/1-variables/font-sizes.variables' as fontSizes;
@use '@ongov/ontario-design-system-global-styles/dist/styles/scss/4-elements/_global.elements.scss';
@use '../../styles/form.scss';
@forward '../../utils/components/error-message/error-message';

$ontario-textarea-border-width: 0.125rem;

.ontario-textarea {
	border: globalVariables.$border-size-standard solid colours.$ontario-colour-black;
	border-radius: globalVariables.$global-radius;
	box-sizing: border-box;
	color: colours.$ontario-colour-black;
	font-size: fontSizes.$ontario-font-size-standard-body-text;
	font-family: fonts.$ontario-font-open-sans;
	line-height: globalVariables.$line-height-default;
	display: block;
	max-width: globalVariables.$standard-width;
	min-height: 144px;
	margin: 0 0 spacing.$spacing-7;
	padding: 0.625rem spacing.$spacing-4;
	transition: focusPlaceholders.$ontario-focus-transition;
	white-space: pre-wrap;
	width: globalVariables.$full-width;

	&:focus,
	&:active {
		@extend %ontario-focus;
	}
}

.ontario-textarea.ontario-textarea-hint-expander--true {
	margin-bottom: spacing.$spacing-4;
}

.ontario-textarea--error {
	textarea {
		border: $ontario-textarea-border-width solid colours.$ontario-colour-alert;
	}
}
